export default {
  backLinkNews: 'All news',
  latestTitle: 'News',
  readNews: 'Read the article',
  otherTitle: 'Other news',
}
